/**
 * @ngdoc directive
 * @name editableField.directive:editableField
 * @description
 * Watches the intended state of a group of inputs and buttons
 */
// @ngInject
module.exports = function () {
    return {
        scope: true,
        controller: 'EditableFieldController',
        compile: function () {
            return {
                pre: function ($scope, $element, attrs, controller) {
                    controller.addField($element);
                    $scope.isEditable = controller.isActive;
                    $scope.$watch(controller.getState, function (state) {
                        $element.toggleClass('submission-datalist-group--active', state === controller.EDIT);
                    });
                }
            };
        }
    };
};
